/**
 * Up-opening footer menu content — personal actions only. Workspace
 * switching lives in WorkspaceSwitcher's own menu, not here (see Rules —
 * shell, "the 620px account menu splits in two").
 * Spec: assets/handoffs/design_handoff_app_shell, Rules — shell / support
 * launcher / settings.
 *
 * Presentational only — AccountRow owns open/close and positions this panel.
 *
 * @param {boolean=false} isAdmin
 * @param {boolean=false} adminNavOpen
 * @param {function=} onToggleAdminNav
 * @param {string=} helpUrl
 * @param {string=} accountSettingsHref
 * @param {string=} affiliatesHref
 * @param {function} onLogout
 */
import React from "react";
import { Link } from "react-router-dom";
import Icon from "../../../theme/untitled/icons/Icon";
import Toggle from "../../../theme/untitled/Toggle/Toggle";
import styles from "./AccountMenu.module.scss";

const AccountMenu = ({
  isAdmin = false,
  adminNavOpen = false,
  onToggleAdminNav,
  helpUrl = "/help",
  accountSettingsHref = "/settings",
  affiliatesHref = "/settings/affiliates",
  onLogout,
  onClose,
}) => (
  <div className={styles.panel} role="menu">
    <Link to={accountSettingsHref} role="menuitem" className={styles.item} onClick={onClose}>
      <Icon name="User01" className={styles.itemIcon} />
      Account settings
    </Link>
    {/* <Link to={affiliatesHref} role="menuitem" className={styles.item} onClick={onClose}>
      <Icon name="Gift01" className={styles.itemIcon} />
      Affiliates
    </Link> */}
    <a href={helpUrl} target="_blank" rel="noreferrer" role="menuitem" className={styles.item}>
      <Icon name="HelpCircle" className={styles.itemIcon} />
      Help articles
    </a>

    {isAdmin && (
      <div className={styles.toggleRow}>
        <span className={styles.toggleLabel}>
          <Icon name="Settings01" className={styles.itemIcon} />
          Admin menu
        </span>
        <Toggle size="sm" checked={adminNavOpen} onChange={onToggleAdminNav} />
      </div>
    )}

    <div className={styles.divider} />

    <button type="button" role="menuitem" className={styles.item} onClick={onLogout}>
      <Icon name="LogOut01" className={styles.itemIcon} />
      Logout
    </button>
  </div>
);

export default AccountMenu;
